module.exports = __webpack_public_path__ + "octoclippy.3309599f0ed7ede136239299b755f3cb.hashedasset.svg";